/**
 * Demo/freemium limit FALLBACK constants.
 * These values are used as fallback defaults when the backend API response does not
 * include the tierLimits field (e.g., during phased rollout or for backward compatibility).
 * The backend tier_config.py TIER_LIMITS is the source of truth for actual limit values.
 * These match the free-tier limits as the most restrictive safe default.
 *
 * See: backend/src/config/tier_config.py TIER_LIMITS['free']
 */

export const DEMO_LIMITS = {
  /** Maximum questions per session for free-tier users (fallback default) */
  MAX_QUESTIONS_PER_SESSION: 2,

  /** Maximum answer attempts per question for free-tier users (fallback default) */
  MAX_ATTEMPTS_PER_QUESTION: 5,

  /** Default max lifetime sessions for free-tier users (fallback; actual value comes from user profile) */
  DEFAULT_MAX_SESSIONS: 2,
} as const;
